export type FlexboxAlign = 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
export type FlexboxJustify = FlexboxAlign | 'space-around' | 'space-between' | 'stretch';
export type FlexboxDirection = 'row' | 'column' | 'row-reverse' | 'column-reverse';
